import React from 'react';
import sizeMe from 'react-sizeme';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './utils/axios-interceptor';

import { EmptyLayout, LayoutRoute, MainLayout } from './framework-layout';
import PageSpinner from './components/PageSpinner';
import Health from './modules/index';

import './styles/reduction.scss';

import TestPost from './modules/testPost';
import AboPicker from './modules/aboPicker'
import Mobile from './modules/mobile';

import { library } from "@fortawesome/fontawesome-svg-core";
//import { faMoon, faRocket, faMagnifyingGlass, faFilter, faSliders, faChevronDown, faChevronRight, faInfo, faClock } from "@fortawesome/free-solid-svg-icons";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

import i18n from "i18next";
import { initReactI18next } from "react-i18next"
import EspEni18n from './modules/esp/i18n/en.json'
import EspMsi18n from './modules/esp/i18n/ms.json'

//library.add(faMoon, faRocket, faMagnifyingGlass,faFilter, faSliders, faChevronDown, faChevronRight, faInfo, faClock);
library.add(fas, far, fab)

// Init translation
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: EspEni18n
      },
      ms: {
        translation: EspMsi18n
      },
    },
    lng: "en",
    fallbackLng: "en",

    interpolation: {
      escapeValue: false
    }
  })

// Import routes
const Routes_shared = require('./routes');

// Combine all routes
const routes = [...Routes_shared.routes];

const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};

// module, to hold the page object
window.message = {};
window.redirect = {};
window.enums = {};

class App extends React.Component {
  getBreakpoint() {
    const { width } = this.props.size; // 'size' is injected by sizeMe

    if (width <= 575) return 'xxs';
    if (width >= 576 && width < 767) return 'xs';
    if (width >= 768 && width < 991) return 'sm';
    if (width >= 992 && width < 1199) return 'md';
    if (width >= 1200 && width < 1920) return 'lg';
    return 'xl';
  }

  render() {
    const currentBreakpoint = this.getBreakpoint();

    return (
      <BrowserRouter basename={getBasename()}>
        <Switch>
          <LayoutRoute
            exact
            path="/testPost"
            layout={EmptyLayout}
            component={() => <TestPost />}
          />

          <LayoutRoute
            exact
            path="/profile"
            layout={EmptyLayout}
            component={() => <AboPicker />}
          />

          <LayoutRoute
            exact
            path="/health"
            layout={EmptyLayout}
            component={() => <Health />}
          />

          <LayoutRoute
            exact
            path="/mobile"
            layout={EmptyLayout}
            component={() => <Mobile />}
          />

          <MainLayout breakpoint={currentBreakpoint}>
            <React.Suspense fallback={<PageSpinner />}>
              <Route exact path="/" component={Routes_shared.LandingPage} />
              <Route
                exact
                path="/home"
                component={Routes_shared.DashboardPage}
              />

              {routes.map((c, i) => (
                <Route exact key={i} path={c.path} component={c.component} />
              ))}
            </React.Suspense>
          </MainLayout>
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    );
  }
}


export default sizeMe({ monitorWidth: true, noPlaceholder: true })(App);
